export const layout = {
    settings: {
        layout_type: "ltr",
        layout: "default",
        sidebar_icon: "stroke-svg",
        sidebar_setting: "compact-wrapper"
    },
    color: {
        layout_version: "light",
        primary_color: "#30648e",
        secondary_color: "#59b8f3"
    }
}